import { cva } from 'class-variance-authority';

export const sessionStatusBadgeVariants = cva('w-fit', {
  variants: {
    status: {
      confirmed: 'bg-denim-200 text-white',
      canceled: 'border border-red-300 bg-red-100 text-red-400',
      done: 'bg-teal-100 text-teal-800',
      completed: 'border border-mint-600 bg-gray-100 text-mint-600',
      pending: 'border border-beige-200 bg-gray-100 text-orange-500',
      scheduled: 'border border-beige-200 bg-gray-100 text-denim-300',
    },
  },
});
